import Router from './routes/Router.tsx';
import EnvironmentIndicator from './components/common/EnvironmentIndicator';
import StaleBuildNotice from './components/common/StaleBuildNotice';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Router />
      <EnvironmentIndicator />
      <StaleBuildNotice />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: '18px',
            padding: '16px 24px',
            minWidth: '400px',
            maxWidth: '500px',
            borderRadius: '12px',
          },
        }}
      />
    </>
  );
}

export default App;
